export const startRequestTimer = () => {
    const requestStartTime = Date.now();
    return {
        stop: () => Date.now() - requestStartTime,
    };
};
//# sourceMappingURL=request-timer.js.map